import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../Common/Layout";
import { Link } from "react-router-dom";
import YearlySalesChart from "./Charts/YearlySalesChart";
import PieChartWithCustomizedLabel from "./Charts/PieChartWithCustomizedLabel";
import StockReport from "./Charts/WeeklySalesChart";

const Dashboard = () => {

const token = sessionStorage.getItem("token");

  const [pestCount, setPestCount] = useState(0);
  const [crdCount, setCrdCount] = useState(0);
  const [cddCount, setCddCount] = useState(0);

  useEffect(() => {
    fetchPestControl();
    fetchCRD();
    fetchCDD();
  }, []);

 const fetchPestControl = async () => {
  try {
    const res = await axios.get(
      "https://irc.zentelex.com/api/pest-control/total-pest-controls",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setPestCount(res.data.totalPestControls);
  } catch (error) {
    console.error("Error fetching pest control count", error);
  }
};




 const fetchCRD = async () => {
  try {
    const res = await axios.get(
      "https://irc.zentelex.com/api/commodity-receipts/total-crd",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setCrdCount(res.data.totalCRD);
  } catch (error) {
    console.error("Error fetching CRD count", error);
  }
};

const fetchCDD = async () => {
  try {
    const res = await axios.get(
      "https://irc.zentelex.com/api/cdd-receipts/total-cdd",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setCddCount(res.data.totalCDD);
  } catch (error) {
    console.error("Error fetching CDD count", error);
  }
};

  return (
    <Layout>
      <div className="container-fluid py-4">
        {/* PAGE HEADER */}
        <div className="mb-4">
          <h3 className="fw-bold">Welcome Back 👋</h3>
          <p className="text-muted mb-0">
            Here’s what’s happening with your business today
          </p>
        </div>

        {/* STAT CARDS */}
        <div className="row g-4 mb-4">
          <DashboardCard
            title="Inbound"
            value={crdCount}
            percent="+2.97%"
            color="primary"
            icon="ri-eye-line"
            link="/report-billing"
            state={{ reportType: "dtr" }} // ✅ auto open DTR
          />

          <DashboardCard
            title="Outbound"
            value={cddCount}
            percent="+18.25%"
            color="success"
            icon="ri-wallet-2-line"
            link="/report-billing"
            state={{ reportType: "dtr" }} // ✅ auto open DTR
          />

          <DashboardCard
            title="Pest Control"
            value={pestCount}
            percent="-5.75%"
            color="info"
            icon="ri-shopping-basket-line"
            link="/paste-control"
          />

          <DashboardCard
            title="Report Billing"
            value="98"
            percent="+8.21%"
            color="warning"
            icon="ri-group-2-line"
            link="/report-billing"
          />
        </div>

        {/* CHARTS ROW 1 */}
        <div className="row g-4 mb-4">
          <div className="col-lg-8">
            <ChartCard>
              <StockReport />
            </ChartCard>
          </div>

          <div className="col-lg-4">
            <ChartCard title="Yearly Sales">
              <YearlySalesChart />
            </ChartCard>
          </div>
        </div>

        {/* CHARTS ROW 2 */}
        <div className="row g-4 mb-4">
          <div className="col-lg-8">
            <ChartCard title="Sales Distribution">
              <PieChartWithCustomizedLabel />
            </ChartCard>
          </div>

          <div className="col-lg-4">
            <ChartCard title="Performance">
              <YearlySalesChart />
            </ChartCard>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;

/* ---------------- COMPONENTS ---------------- */

const DashboardCard = ({
  title,
  value,
  percent,
  color,
  icon,
  link,
  state, // ✅ add this
}) => (
  <div className="col-xxl-3 col-sm-6">
    <div
      className={`card text-bg-${color} shadow-sm rounded-4 h-100`}
      style={{ transition: "0.3s" }}
    >
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="fw-semibold mb-0">{title}</h6>
          <i className={`${icon} fs-3 opacity-75`}></i>
        </div>

        <h2 className="fw-bold mt-3">{value}</h2>

        <p className="mb-3">
          <span className="badge bg-light text-dark me-2">{percent}</span>
          Since last month
        </p>

        {/* ✅ pass state here */}
        <Link to={link} state={state} className="btn btn-light btn-sm w-100">
          View Details →
        </Link>
      </div>
    </div>
  </div>
);

const ChartCard = ({ title, children }) => (
  <div className="card shadow-sm rounded-4 h-100">
    <div className="card-body">
      <h6 className="fw-semibold mb-3">{title}</h6>
      {children}
    </div>
  </div>
);

const ProjectRow = ({ id, name, status, statusColor }) => (
  <tr>
    <td>{id}</td>
    <td>{name}</td>
    <td>01/01/2015</td>
    <td>26/04/2015</td>
    <td>
      <span className={`badge bg-${statusColor}-subtle text-${statusColor}`}>
        {status}
      </span>
    </td>
    <td>Techzaa Studio</td>
  </tr>
);

